const LoadingIndicator = ({ label = 'Loading…', inline = false }) => (
  <div className={`loading-indicator ${inline ? 'loading-indicator--inline' : ''}`} role="status" aria-live="polite">
    <span className="loading-indicator__spinner" aria-hidden="true" />
    <span className="loading-indicator__label">{label}</span>
  </div>
)

export default LoadingIndicator
